<!--
 * @Author: zhangmh31513
 * @Date: 2021-09-07 09:15:18
 * @LastEditTime: 2021-11-15 13:51:32
 * @LastEditors: zhangmh31513
 * @Description:
 * @FilePath: \openplat-web\src\gtn\views\frontViews\developerConference\developerConference.vue
 * 有问题请第一时间来联系我
-->
<template>
  <div class="main-content">
    <conference-header @pf="refreshTicket"></conference-header>
    <router-view ref="ticketPage" />
    <CooperateIcon />

    <starPopup
      :show.sync="isEnrollTips"
      v-if="isEnrollTips"
      tips="云上展厅即将上线，敬请期待！"
    ></starPopup>
    <!-- 光子提示 -->
    <ScanToAnswer :show="lightShow" :photonNum="photonNum" @close="onClose" />
    <globFooter
      v-if="
        ['conferenceIndex', 'cloudMeeting', 'cloudShow'].indexOf(activeName) < 0
      "
    ></globFooter>
  </div>
</template>
<script>
import ConferenceHeader from "@/views/frontViews/developerConference/components/conferenceHeader";
import CooperateIcon from "./components/cooperateIcon.vue";
import starPopup from "./components/tipPopup";
import ScanToAnswer from "@/components/pnoton";

import globFooter from "@/views/frontViews/components/globFooter";
import { mapGetters, mapActions } from "vuex";
import { get_signup_end_time } from "@/api/developerConference.js";
// import { isWeiXin,shara } from '@/api/developerConference.js'
export default {
  data() {
    return {};
  },

  components: {
    ConferenceHeader,
    globFooter,
    CooperateIcon,
    starPopup,
    ScanToAnswer
  },

  computed: {
    ...mapGetters(["isEnrollTips", "photonNum", "lightShow"]),
    activeName() {
      return this.$route.path.split("/")[2];
    }
  },

  created() {
    this.getTimeStamp();
  },
  mounted() {
    // 从url上获取渠道来源channel_source
    this.getQueryStr();
    this.wxShare(
      "2021LIGHT开发者云大会",
      "天生有为 BORN TO BE LIGHT",
      window.location.href,
      "https://" +
        location.hostname +
        "/r/cms/www/itn/images/deveConfere/pc_logo.png"
    ),
      dd.ready(function() {
        if (dd) {
          dd.biz.navigation.setTitle({
            title: "2021恒生LIGHT开发者云大会", // 控制标题文本，空字符串表示显示默认文本
            onSuccess: function(result) {
              console.log(result);
            },
            onFail: function(err) {
              // alert('钉钉设置标题失败')
            }
          });
          dd.biz.navigation.setRight({
            show: true, //控制按钮显示， true 显示， false 隐藏， 默认true
            control: true, //是否控制点击事件，true 控制，false 不控制， 默认false
            text: "...", //控制显示文本，空字符串表示显示默认文本
            onSuccess: function(result) {
              //如果control为true，则onSuccess将在发生按钮点击事件被回调
              dd.biz.util.share({
                type: 0, //分享类型，0:全部组件 默认； 1:只能分享到钉钉；2:不能分享，只有刷新按钮
                url: window.location.href,
                content: "天生有为 BORN TO BE LIGHT",
                title: "2021恒生LIGHT开发者云大会",
                image:
                  "https://" +
                  location.hostname +
                  "/r/cms/www/itn/images/deveConfere/share_logo.png",
                onSuccess: function() {},
                onFail: function(err) {}
              });
            },
            onFail: function(err) {}
          });
        }
      });
  },

  methods: {
    ...mapActions(["timeover", "enrolltips", "changeLightData"]),
    // 分离出携带的参数
    getQueryStr(url = location.href) {
      const search = decodeURIComponent(url.split("?")[1]).replace(/\+/g, " ");
      if (!search) {
        return;
      }
      const searchArr = search.split("&");
      searchArr.forEach(v => {
        const index = v.indexOf("=");
        if (index !== -1) {
          const name = v.substring(0, index);
          const val = v.substring(index + 1, v.length);
          sessionStorage.setItem(name, val);
        }
      });
    },
    // 获取报名时间是否超时状态位
    getTimeStamp() {
      get_signup_end_time().then(res => {
        if (res) {
          this.timeover({ diffTime: res.diff_time });
        }
      });
    },
    refreshTicket() {
      if (window.location.href.indexOf("ticketType") != -1) {
        this.$refs.ticketPage.reflesh();
      }
    },
    // 关闭光子组件
    onClose() {
      this.changeLightData({ photonNum: 0, lightShow: false });
    }
  }
};
</script>
<style lang="scss" scoped>
.main-content {
  background: #f1f2f7;
  min-width: 1200px;
}
</style>
<style>
body {
  /* 为了消除横向滚动条 */
  /* overflow-x: hidden; */
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/developerConference.vue